import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { useProfile } from '../context/ProfileContext';

const AgentProfile = () => {
  const { profile, saveProfile, showProfilePanel, setShowProfilePanel } = useProfile();
  const [formData, setFormData] = useState(profile);
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    setFormData(profile);
  }, [profile, showProfilePanel]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = (e) => {
    e.preventDefault();
    saveProfile(formData);
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
      setShowProfilePanel(false);
    }, 1500);
  };

  return (
    <AnimatePresence>
      {showProfilePanel && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowProfilePanel(false)}
            className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-50"
          />
          <motion.div
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 200 }}
            className="fixed right-0 top-0 h-full w-full max-w-md bg-white shadow-2xl z-[60] overflow-y-auto"
          >
            <div className="p-6">
              <div className="flex justify-between items-center mb-8">
                <h2 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
                  <SafeIcon name="User" className="text-blue-600" />
                  Agent Profile
                </h2>
                <button 
                  onClick={() => setShowProfilePanel(false)}
                  className="p-2 hover:bg-slate-100 rounded-full transition-colors"
                >
                  <SafeIcon name="X" className="text-slate-500 w-6 h-6" />
                </button>
              </div>

              <form onSubmit={handleSave} className="space-y-5">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1">First Name</label>
                    <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" placeholder="John" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1">Last Name</label>
                    <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" placeholder="Doe" />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Email Address</label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" placeholder="john.doe@avoyatravel.com" />
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Phone Number</label>
                  <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" placeholder="(555) 123-4567" />
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Agency Name</label>
                  <input type="text" name="agencyName" value={formData.agencyName} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" />
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Tagline or Specialty</label>
                  <input type="text" name="tagline" value={formData.tagline} onChange={handleChange} className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" placeholder="Caribbean & Mediterranean Specialist" />
                </div>

                <div className="pt-4">
                  <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 rounded-lg flex items-center justify-center gap-2 transition-all">
                    <SafeIcon name="Save" />
                    Save Changes
                  </button>
                </div>
              </form>

              <AnimatePresence>
                {showToast && (
                  <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0 }}
                    className="mt-6 p-3 bg-green-50 border border-green-200 text-green-700 rounded-lg flex items-center justify-center gap-2 font-medium"
                  >
                    <SafeIcon name="CheckCircle" />
                    Profile saved!
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default AgentProfile;